// import React from "react";

// const images = [
//   { src: "/Hospital Main Building.jpeg", name: "Hospital Main Building" }, 
//   { src: "/Endoscopy complex.jpeg", name: "Endoscopy Complex" },
//   { src: "/CT scan.jpeg", name: "CT Scan Room" },
//   { src: "/Radiology CT scan.jpeg", name: "Radiology CT Scan" },
//   { src: "/Endoscopy suite.jpeg", name: "Endoscopy Suite" },
//   { src: "/Endoscopy suite 2.jpeg", name: "Endoscopy Suite 2" },
//   { src: "/Pathology Lab.jpeg", name: "Pathology Lab" },
//   { src: "/Fibroscan.jpeg", name: "Fibroscan Room" },
//   { src: "/ICU.jpeg", name: "ICU" },
// ];

// const Gallery = () => {
//   return (
//     <section style={styles.section}>
//       <h2 style={styles.heading} className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900  p-2">Hospital Gallery</h2>

//       <div style={styles.grid}>
//         {images.map((img, index) => (
//           <div key={index} style={styles.card}>
//             <img src={img.src} alt={img.name} style={styles.image} />

            
//             <p style={styles.caption}>{img.name}</p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// const styles = {
//   section: {
//     padding: "60px 20px",
//     background: "#f9f9f9",
//     textAlign: "center",
//   },

//   heading: {
//     fontSize: "32px",
//     marginBottom: "40px",
//     color: "#1a3c6e",
//   },

//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//     gap: "20px",
//     maxWidth: "1200px",
//     margin: "auto",
//   },

//   card: {
//     overflow: "hidden",
//     borderRadius: "10px",
//     boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//     background: "#fff",
//   },

//   image: {
//     width: "100%",
//     height: "220px",
//     objectFit: "cover",
//   },

//   caption: {
//     padding: "10px",
//     fontSize: "16px",
//     fontWeight: "500",
//     color: "#333",
//   },
// };

// export default Gallery;


import React from "react";

const images = [
  { src: "/Hospital Main Building.jpeg", name: "Hospital Main Building" },
  { src: "/Endoscopy complex.jpeg", name: "Endoscopy Complex" },
  { src: "/CT scan.jpeg", name: "CT Scan Room" },
  { src: "/Radiology CT scan.jpeg", name: "Radiology CT Scan" },
  { src: "/Endoscopy suite.jpeg", name: "Endoscopy Suite" },
  { src: "/Endoscopy suite 2.jpeg", name: "Endoscopy Suite 2" },
  { src: "/Pathology Lab.jpeg", name: "Pathology Lab" },
  { src: "/Fibroscan.jpeg", name: "Fibroscan Room" },
  { src: "/ICU.jpeg", name: "ICU" },
];

const Gallery = () => {
  return (
    <section id="gallery" className="py-10 bg-slate-50">
      <div className="max-w-5xl mx-auto px-6">
        
        {/* Section Header - Reduced margin */}
        <div className="text-center mb-8">
          <span className="text-[#800000] font-semibold text-sm uppercase tracking-wide">
            Our Facility
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 p-2">
            Hospital Gallery
          </h2>
        </div>

        {/* Gallery Grid - 3 items per row, smaller gap */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {images.map((img, index) => (
            <div
              key={index}
              className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 border border-slate-100"
            >
              {/* Image Link - Shorter aspect ratio (Video style) */}
              <a 
                href={img.src} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="block relative overflow-hidden aspect-video bg-slate-200"
              >
                <img
                  src={img.src}
                  alt={img.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" 
                />
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-slate-900/10 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                  <div className="bg-white/80 p-2 rounded-full shadow-lg transform scale-90 group-hover:scale-100 transition-transform">
                    {/* Tiny search icon or plus icon placeholder */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-[#800000]"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                  </div>
                </div>
              </a>

              {/* Caption - Reduced padding and font size */}
              <div className="py-2 px-3 text-center bg-white">
                <p className="text-slate-700 font-bold text-[11px] md:text-xs uppercase tracking-tight truncate p-2">
                  {img.name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;